import { Autocomplete, Stack, TextField, Typography } from "@mui/material";
import { ColorsConstants } from "../../../../cssUtils/constants";
import { StringField } from "../ConfigFields/StringField";
import { NumberField } from "../ConfigFields/NumberField";
import { BooleanField } from "../ConfigFields/BooleanField";

const SendOtpPreset = ({ schema, config, handleConfigChange, templates }) => {
  // The OTP goes out as a WhatsApp Authentication template.
  const authTemplates = (templates || []).filter(
    (template) => template?.category === "AUTHENTICATION",
  );
  const properties = schema?.properties || {};

  // Nodes saved before the setting existed run in demo mode, so show it as on.
  const demoMode = config["demo_mode"] ?? true;

  return (
    <Stack spacing={3}>
      <BooleanField
        fieldKey="demo_mode"
        schema={properties.demo_mode || {}}
        value={demoMode}
        required={false}
        onChange={(val) => handleConfigChange("demo_mode", val)}
      />
      {demoMode && (
        <Typography variant="body2" color={ColorsConstants.grayFontColor}>
          Demo mode: no OTP is sent. Switch it off to send a real OTP with the
          settings below.
        </Typography>
      )}

      <Autocomplete
        options={authTemplates}
        value={
          authTemplates.find(
            (template) => template?.template_id === config["template_id"],
          ) || null
        }
        onChange={(e, newValue) =>
          handleConfigChange("template_id", newValue?.template_id || "")
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Authentication Template"
            variant="outlined"
            helperText="Leave empty to use the tenant's default OTP template."
          />
        )}
        getOptionLabel={(option) => option?.template_name || ""}
        renderOption={(props, option) => (
          <Stack
            {...props}
            key={option?.id}
            direction="column"
            gap={0.5}
            sx={{
              alignItems: "flex-start !important",
              textAlign: "left",
              width: "100%",
            }}
          >
            <Typography>{option?.template_name}</Typography>
            <Typography variant="body2" color={ColorsConstants.primaryGray40}>
              Authentication
            </Typography>
          </Stack>
        )}
        isOptionEqualToValue={(option, value) =>
          option?.template_id === value?.template_id
        }
        noOptionsText="No Authentication templates found"
      />

      <StringField
        fieldKey="phone_variable"
        schema={properties.phone_variable || {}}
        value={config["phone_variable"]}
        required={false}
        onChange={(val) => handleConfigChange("phone_variable", val)}
      />
      <StringField
        fieldKey="country_code"
        schema={properties.country_code || {}}
        value={config["country_code"]}
        required={false}
        onChange={(val) => handleConfigChange("country_code", val)}
      />
      <StringField
        fieldKey="context"
        schema={properties.context || {}}
        value={config["context"]}
        required={false}
        onChange={(val) => handleConfigChange("context", val)}
      />
      <NumberField
        fieldKey="ttl_seconds"
        schema={properties.ttl_seconds || {}}
        value={config["ttl_seconds"]}
        required={false}
        onChange={(val) => handleConfigChange("ttl_seconds", val)}
      />
    </Stack>
  );
};

export default SendOtpPreset;
